import React from 'react';
import styled from 'styled-components';
import { heightMobile } from './constants';

const StyledSidebar = styled.div<{ opened: Boolean }>`
    width: ${(props) => (props.opened ? '100vw' : '0px')};
    height: 100vh;
    position: fixed;
    z-index: 1000;
    background-color:rgba(0, 0, 0, 0.6);
    top: ${heightMobile};
    right: 0;
    
    ${(props) => props.theme.mediaQuerie.minWidth.md} {
      top: 0;          
    }

    .sidebar {
        transition: width 0.15s;
        width: ${(props) => (props.opened ? '257px' : '0px')};
        position: absolute;
        height: 100vh;
        z-index: 1001;
        background-color: white;
        top: 0;
        right: 0;

        .topmenu-button {
          display: none;
        }

        .sidebar-header {
          display: none;
          button {
            &:hover, &:active {
              background-color: transparent;
            }
          }
        }

        ${(props) => props.theme.mediaQuerie.minWidth.md} {
          .topmenu-button {
            display: block;
          }            
        }

        ${(props) => props.theme.mediaQuerie.minWidth.md} {
          .sidebar-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 22px;

            button {
              margin: 0;
              padding: 0;

              display: flex;

            }
          }      
        }

        .sidebar-content {
          display: ${(props) => (props.opened ? 'flex' : 'none')};
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 80%;

        }
    }

    .scale-up-top {
      animation: scale-up-top 0.5s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
    }

    @keyframes scale-up-top {
      0% {
        transform: scale(0.1);
        transform-origin: 50% 0%;
      }
      100% {
        transform: scale(1);
        transform-origin: 50% 0%;
      }
    }

`;

const Sidebar = ({ opened, children }: { opened: boolean, children: any }) => (
  <StyledSidebar opened={opened}>
    <div className="sidebar">{children}</div>
  </StyledSidebar>
);

export default Sidebar;
